import TableCustomized from "../../../common/components/TableCustomized";
import PaperCustomized from "../../../common/components/PaperCustomized";

function ListPaysProvenances(props) {
  const columns = [
    {
      field: "paysOrigine",
      headerName: "Pays de provenances",
      minWidth: 450,
      flex: 1,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
  ];
  const rows = [];
  props?.detail?.paysTitreImportation?.map((row, index) => {
    rows.push({
      id: row.id,
      paysOrigine: row.pays?.description,
    });
  });
  return (
    <PaperCustomized title={"Pays de provenances"} forActions={false}>
      <TableCustomized
        columns={columns}
        rows={rows}
        totalElements={rows.length}
        pageSizeOptions={[10, 25, 50, 100]}
        paginationMode="client"
        isSlots={false}
        isFooter={true}
        noDataHeight="120px"
        cursor="auto"
      />
    </PaperCustomized>
  );
}

export default ListPaysProvenances;
